import SeoMainBanner from './SeoMainBanner';

export default SeoMainBanner;
